export function getRandomHeaderImage() {
  const rn = Math.floor(Math.random() * 17) + 1;
  return `https://firebasestorage.googleapis.com/v0/b/thunk-production.appspot.com/o/assets%2F${rn}.webp?alt=media`;
}
